import axios from "axios";

export class DocumentDownloadService {
    private documentURL = "/api/v1/documents";

    async downloadDocument(documentMetadataID: string, filename: string): Promise<void> {
        try {
            // add an HTML anchor element to the page linking to the document to download
            const anchor = document.createElement("a");
            document.body.appendChild(anchor);
            const requestPath = this.documentURL + "/" + documentMetadataID;

            // get document from server and prepare to download it to browser
            const blob = (await axios.get(requestPath, { responseType: "blob" })).data as Blob;
            const objectUrl = window.URL.createObjectURL(blob);

            anchor.href = objectUrl;
            anchor.download = filename;

            // click the link to download the document
            anchor.click();

            // clean up the link
            window.URL.revokeObjectURL(objectUrl);
            document.body.removeChild(anchor);
        } catch (err) {
            console.log(err);
            alert(`Error downloading ${filename}`);
        }
    }
}
